import { Box, BoxProps } from '@chakra-ui/react';
import { customTheme } from 'theme';

const OutpostStatus = ['Active', 'Inactive'];

export const outpostStatusOptions = OutpostStatus.map(o => ({
  label: o,
  value: o,
}));

const OutpostType = ['Data', 'Vulnerability'];

export const outpostTypeOptions = [
  { label: 'Type', value: undefined },
  ...OutpostType.map(o => ({
    label: o,
    value: o,
  })),
];

export const OutpostInfoBox = (props: BoxProps) => {
  return (
    <Box
      border="1px solid"
      borderColor={customTheme.colors.gray['100']}
      borderRadius={10}
      px={4}
      py={2}
      {...props}
    />
  );
};
